import { useQuery } from '@tanstack/react-query';

import { getCsDashboardStats } from '~/services/CsDashboardService';

import { reportingQueryKeys } from './reportingQueryKeys';

export function useCsDashboardStats(params: { featureIds: string[]; startAt?: string; endAt?: string }) {
  return useQuery({
    queryKey: reportingQueryKeys.csDashboardStats(params.featureIds, params.startAt, params.endAt),
    queryFn: ({ signal }) => getCsDashboardStats(params, { signal }),
    enabled: params.featureIds.length > 0,
  });
}
